export const SUMSUB_STATUSES = {
  RED: 'RED',
  GREEN: 'GREEN',
};
